/**
 * Typography Control Group - Main Export File
 *
 * This module exports the TypographyControl component along with its related types
 * and utilities for use throughout the Redfox Thank You plugin.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

// Import styles (webpack will handle this)
import './style.scss';

// Export the main component
export { TypographyControl } from './component';

// Export premium components (for pro plugins)
export {
	FontFamilyControl,
	FontStyleControl,
	FontWeightControl,
	LetterSpacingControl,
	TextTransformControl,
	WordSpacingControl,
} from './premium';

// Export utility functions
export {
	getTypographyValues,
	hasAnyTypographyValues,
	resetTypographyAttributes,
	updateTypographyProperty,
} from './utils';

// Export TypeScript interfaces and types
export type {
	FontFamilyOption,
	ResponsiveBreakpoint,
	TypographyAttributes,
	TypographyControlProps,
	TypographyResetOptions,
	TypographyValues,
} from './types';

// Export premium component types
export type { TypographyControlComponentProps } from './premium';

// Export constants
export {
	DEFAULT_ENABLED_CONTROLS,
	DEFAULT_FONT_FAMILY_OPTIONS,
	fontStyleOptions,
	fontWeightOptions,
	textTransformOptions,
	TYPOGRAPHY_UNITS,
} from './constants';
export { generateTypographyCSSRules, getTypographyCSS } from './style';
